<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>用户数据权限</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-card shadow="hover">
            <!-- 搜索 -->
            <el-form :inline="true" size="small" v-model="listQuery">
                <el-form-item label="用户">
                    <el-select v-model="listQuery.userName" clearable placeholder="请选择" filterable>
                        <el-option v-for="(item, index) in sysUserList" :key="index"
                            :label="item.userName + item.userAccount" :value="item.userName"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="类型">
                    <el-select v-model="listQuery.type" clearable placeholder="请选择类型" filterable>
                        <el-option v-for="(item, index) in typeMap" :key="index" :label="item" :value="index"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item>
                    <el-button icon="el-icon-search" type="primary" plan @click="querySearch">查询</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" class="el-icon-plus" plan @click="addUserData">新增数据权限</el-button>
                    <el-button type="primary" class="el-icon-plus" plan @click="addSourceUserData">渠道权限</el-button>
                    <el-button type="primary" class="el-icon-plus" plan @click="addSourceTypeData">渠道类型权限</el-button>

                    <el-button class type="success" plan @click="syncWorker">同步账号数据</el-button>
                </el-form-item>

            </el-form>

            <!-- 列表数据 -->
            <el-table :data="listData" border style="width: 100%" class="table">
                <el-table-column type="index" label="序号" width="55"></el-table-column>
                <el-table-column prop="userId" label="用户编号" width="80"></el-table-column>
                <el-table-column prop="userName" label="用户名" width="80"></el-table-column>
                <el-table-column prop="userAccount" label="账号" width="110"></el-table-column>
                <el-table-column prop="type" label="数据类型" width="80">
                    <template slot-scope="scope">
                        <!-- a城市，b驿站，c服务站 -->
                        <!-- <span v-if="scope.row.type=='a'">城市</span>
                        <span v-if="scope.row.type=='b'">驿站</span>
                        <span v-if="scope.row.type=='c'">服务站</span> -->
                        {{ typeMap[scope.row.type] }}
                    </template>
                </el-table-column>
                <el-table-column prop="dataName" label="数据名称" width="355"></el-table-column>
                <el-table-column prop="dataArr" label="数据编码" width="355"></el-table-column>
                <el-table-column prop="codeArr" label="数据code" width="355"></el-table-column>

                <el-table-column prop="createTime" :formatter="dateFormatA" label="创建时间"></el-table-column>
                <el-table-column prop="updateTime" :formatter="dateFormatA" label="修改时间"></el-table-column>
                <el-table-column label="操作" fixed="right" width="150">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.type =='a' || scope.row.type == 'b' || scope.row.type == 'c'" type="text"
                            icon="el-icon-edit" @click="updateUserData(scope.row)">编辑服务站</el-button>
                        <el-button v-else type="text" icon="el-icon-edit" @click="delUserData(scope.row)">删除权限</el-button>

                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <pagination :total="total" :page.sync="currentPage" :limit.sync="pageSize" @pagination="querySearch" />
        </el-card>

        <el-dialog title="数据权限编辑" :visible.sync="showAdd" width="600px" :close-on-click-modal="false" center>
            <el-form>
                <el-form-item label="用户">
                    <el-select v-model="addFrom.userId" clearable placeholder="请选择" filterable>
                        <el-option v-for="(item, index) in sysUserList" :key="index"
                            :label="item.userName + item.userAccount" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>

                <el-tree :data="allTreeData" show-checkbox node-key="id" ref="tree" :default-expanded-keys="expandedKeys"
                    :props="defaultProps">
                </el-tree>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="expandTree">展开</el-button>
                <el-button @click="foldTree">折叠</el-button>
                <el-button @click="$refs.tree.setCheckedNodes(allTreeData)">全选</el-button>
                <el-button @click="$refs.tree.setCheckedKeys([])">取消选择</el-button>
                <el-button type="primary" @click="saveUserData">提交</el-button>
                <el-button @click="showAdd = false">关闭</el-button>
            </span>
        </el-dialog>

        <el-dialog title="配置用户渠道权限" :visible.sync="showStoreAdd" width="600px" :close-on-click-modal="false" center>
            <el-form>
                <el-form-item label="用户">
                    <el-select v-model="addStoreFrom.userId" clearable placeholder="请选择" filterable>
                        <el-option v-for="(item, index) in sysUserList" :key="index"
                            :label="item.userName + item.userAccount" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="来源类型">
                    <el-select v-model="addStoreFrom.type" @change="clearqd" clearable placeholder="来源类型">
                        <el-option value="e1" label="外部渠道"></el-option>
                        <el-option value="e3" label="自招"></el-option>
                        <el-option value="e4" label="转介绍"></el-option>
                        <el-option value="e7" label="自有渠道"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="渠道">
                    <el-select v-model="addStoreFrom.sourceIds" clearable placeholder="请选择渠道" multiple>
                        <template v-for="(item, index) in sourceList">
                            <el-option v-if="addStoreFrom.type == ('e' + item.sourceType)" :key="index" :label="item.name"
                                :value="item.id + ',' + item.name"></el-option>
                        </template>
                    </el-select>
                </el-form-item>

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveUserSourceData">提交</el-button>
                <el-button @click="showStoreAdd = false">关闭</el-button>
            </span>
        </el-dialog>

        <el-dialog title="配置用户来源类型" :visible.sync="showStoreAddType" width="600px" :close-on-click-modal="false" center>
            <el-form>
                <el-form-item label="用户">
                    <el-select v-model="addStoreTypeFrom.userId" clearable placeholder="请选择" filterable>
                        <el-option v-for="(item, index) in sysUserList" :key="index"
                            :label="item.userName + item.userAccount" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="来源类型">
                    <el-select v-model="addStoreTypeFrom.typeList"  multiple clearable placeholder="来源类型">
                        <el-option value="1,外部渠道" label="外部渠道"></el-option>
                        <el-option value="3,自招" label="自招"></el-option>
                        <el-option value="4,转介绍" label="转介绍"></el-option>
                        <el-option value="7,自有渠道" label="自有渠道"></el-option>
                    </el-select>
                </el-form-item> 

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveSourceTypeData">提交</el-button>
                <el-button @click="showStoreAddType = false">关闭</el-button>
            </span>
        </el-dialog>

    </div>
</template>
<script>
import moment from "moment";
import Pagination from "@/components/common/Pagination";
import wmsApi from "@/script/api/wmsApi";
import service from "@/script/api/service";
import crmApi from "@/script/api/workercrmapi";
import globalData from "@/components/common/globaldata/global.data.vue";
let vm;
export default {
    components: { Pagination },
    data() {
        return {
            addStoreTypeFrom:{
                userId: null,
                userName: null,
                typeList: [], 
            },
            sourceList: [],
            addStoreFrom: {
                userId: null,
                userName: null,
                type: null,
                sourceIds: [],
                dataList: [],
            },
            showStoreAdd: false,
            showStoreAddType:false,
            typeMap: {
                'a': '城市', 'b': '驿站', 'c': '服务站',
                'd': '线索来源类型', 
                'e1': '外部渠道', 'e3': '自招', 'e4': '转介绍', 'e7': '自有渠道'
            },
            expandedKeys: [],
            isExpand: false,
            defaultProps: {
                children: "children",
                label: "label",
            },
            sysUserList: [],
            allTreeData: [],
            total: 0,
            pageSize: 10,
            currentPage: 1, //当前页
            listData: [],
            listQuery: {
                userName: null,
                type: '',
            },
            addFrom: {
                userId: null,
                userName: null,
                dataList: [],
            },
            showAdd: false,
            isbz: false,
        };
    },

    created() {
        this.getSysUser();

        this.querySearch();
    },
    methods: {
        saveSourceTypeData(){
            if (this.addStoreTypeFrom.userId == null || this.addStoreTypeFrom.userId == "") {
                this.$message.error("请选择用户");
                return;
            }
            if (this.addStoreTypeFrom.typeList.length == 0) {
                this.$message.error("请选择来源类型");
                return;
            }

            let nm = null;
            this.sysUserList.forEach((e) => {
                if (e.id == this.addStoreTypeFrom.userId) {
                    nm = e.userName;
                }
            });
            this.addStoreTypeFrom.userName = nm;

            let dataList = []; 
            this.addStoreTypeFrom.typeList.forEach(item => {
                let row = item.split(",");
                let temp = { dataId: row[0], label: row[1], id:'d', type:'d' };
                dataList.push(temp);
            })
            this.addStoreTypeFrom.dataList = dataList; 

            crmApi.$ajaxemSysUserDataAddUserData(this.addStoreTypeFrom).then((res) => {
                if (res.data.errno == 0) {
                    this.$message.success("操作成功");
                    this.showStoreAddType = false;
                    this.querySearch();
                } else {
                    this.$message.error(res.data.data);
                }
            });
        },
        addSourceTypeData(){
            this.showStoreAddType = true;
            this.addStoreTypeFrom = {
                userId: null,
                userName: null,
                typeList: [], 
            }; 
        }, 
        clearqd() {
            this.addStoreFrom.sourceIds = [];
        },
        delUserData(row) {
            this.$confirm("是否确认删除 " + row.userName + ': （' + row.dataName + "）权限?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    crmApi.$ajaxemSysUserDataDeleteUserData({ id: row.id }).then((res) => {
                        if (res.data.errno == 0) {
                            this.$message.success("操作成功");

                            this.querySearch();
                        } else {
                            this.$message.error(res.data.data);
                        }
                    });
                })
                .catch(() => { });

        },
        saveUserSourceData() {
            if (this.addStoreFrom.userId == null || this.addStoreFrom.userId == "") {
                this.$message.error("请选择用户");
                return;
            }
            if (this.addStoreFrom.sourceIds.length == 0) {
                this.$message.error("请选择渠道");
                return;
            }

            let nm = null;
            this.sysUserList.forEach((e) => {
                if (e.id == this.addStoreFrom.userId) {
                    nm = e.userName;
                }
            });
            this.addStoreFrom.userName = nm;

            let dataList = [];
            let tp = this.addStoreFrom.type;
            this.addStoreFrom.sourceIds.forEach(item => {
                let row = item.split(",");
                let temp = { dataId: row[0], label: row[1], id: tp, type: tp };
                dataList.push(temp);
            })
            this.addStoreFrom.dataList = dataList;
            console.log(this.addStoreFrom.dataList);

            crmApi.$ajaxemSysUserDataAddUserData(this.addStoreFrom).then((res) => {
                if (res.data.errno == 0) {
                    this.$message.success("操作成功");
                    this.showStoreAdd = false;
                    this.querySearch();
                } else {
                    this.$message.error(res.data.data);
                }
            });
        },
        addSourceUserData() {
            this.showStoreAdd = true;
            this.addStoreFrom = {
                userId: null,
                userName: null,
                type: null,
                sourceIds: [],
                dataList: [],
            };
            this.getSupplierList();
        },
        getSupplierList() {
            //获取渠道门店
            crmApi
                .$axiosGetSupplierList({
                    companyId: globalData.company.id,
                    // filterType: 1
                })
                .then(res => {
                    this.sourceList = res.data.data;
                });
        },
        syncWorker() {
            crmApi
                .$axiossyncWorkerData()
                .then((res) => {
                    this.$message.success('操作成功');
                });
        },
        addUserData() {
            this.showAdd = true;
            this.isbz = false;

            this.addFrom = {
                userId: null,
                userName: null,
                dataList: [],
            };

            this.getTreeAllData();
            this.$refs.tree.setCheckedKeys([]);
        },
        updateUserData(row) {
            this.showAdd = true;
            this.isbz = true;

            this.addFrom = {
                userId: row.userId,
                userName: row.userName,
                dataList: [],
            };

            this.getTreeAllData();
            this.getUserDataCPS(row);
        },
        getUserDataCPS(row) {
            crmApi
                .$ajaxemSysUserDataGetUserDataCPS({ userId: row.userId })
                .then((res) => {
                    if (res.data.errno == 0) {
                        console.log(res.data.data);
                        this.$refs.tree.setCheckedKeys(res.data.data);
                        this.expandedKeys = res.data.data;
                    } else {
                        this.$message.error(res.data.data);
                    }
                });
        },
        setFormData() {
            let nm = null;
            this.sysUserList.forEach((e) => {
                if (e.id == this.addFrom.userId) {
                    nm = e.userName;
                }
            });
            this.addFrom.userName = nm; //姓名
            this.addFrom.dataList = this.$refs.tree.getCheckedNodes(false, true);
            // let fu =this.$refs.tree.getHalfCheckedKeys()//返回选中子节点的父节点的key
            //  this.addFrom.dataList=this.addFrom.dataList.concat(fu)

            //          let zi = this.$refs.tree.getCheckedKeys()//返回选中子节点的key

        },
        saveUserData() {
            if (this.addFrom.userId == null || this.addFrom.userId == "") {
                this.$message.error("请选择用户");
                return;
            }

            this.setFormData();
            console.log(this.addFrom);

            if (this.isbz) {
                crmApi
                    .$ajaxemSysUserDataUpdateUserData(this.addFrom)
                    .then((res) => {
                        if (res.data.errno == 0) {
                            this.$message.success("操作成功");
                            this.showAdd = false;
                            this.querySearch();
                        } else {
                            this.$message.error(res.data.data);
                        }
                    });
                return;
            }

            crmApi.$ajaxemSysUserDataAddUserData(this.addFrom).then((res) => {
                if (res.data.errno == 0) {
                    this.$message.success("操作成功");
                    this.showAdd = false;
                    this.querySearch();
                } else {
                    this.$message.error(res.data.data);
                }
            });
        },

        //查询
        querySearch() {
            this.listQuery.pageSize = this.pageSize;
            this.listQuery.pageNum = this.currentPage;
            crmApi
                .$ajaxemSysUserDataPagePageList(this.listQuery)
                .then((res) => {
                    if (res.data.errno == 0) {
                        this.listData = res.data.data.list;
                        this.total = res.data.data.total;
                    }
                });
        },
        expandTree() {
            this.isExpand = true;
            this.buildData();
        },
        foldTree() {
            this.isExpand = false;
            this.buildData();
        },
        buildData() {
            for (
                let i = 0;
                i < this.$refs.tree.store._getAllNodes().length;
                i++
            ) {
                this.$refs.tree.store._getAllNodes()[i].expanded =
                    this.isExpand;
            }
        },
        getTreeAllData() {
            service.$axioSysUserGetTreeAllData().then((res) => {
                if (res.data.errno == 0) {
                    this.allTreeData = res.data.data;
                }
            });
        },
        getSysUser() {
            service.$axiosSysUsergetallUser().then((res) => {
                if (res.data.errno == 0) {
                    this.sysUserList = res.data.data;
                }
            });
        },
    },
    beforeCreate() {
        vm = this;
    },
};
</script>
<style scoped>
.crumbs {
    margin: 0 0 10px 0;
}

.btn-margin .el-button--small {
    margin: 10px 12px 0 0;
}

.el-image img {
    height: 60px;
    width: 60px;
    margin: 0 12px 12px 0;
    object-fit: cover;
}
</style>